/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  BatchModeTransaction,
  BatchOperation,
  BatchOperationAdd,
  ConcurrencyError,
  IPickerModel,
} from '@rhybus/api'
import React, { useContext, useEffect, useRef, useState } from 'react'

import { sitePath } from '../../../assets/ts/api/api'
import { mpfRListsHttp } from '../../../assets/ts/api/mpf-r-lists-http'
import { mpfWhoHttp } from '../../../assets/ts/api/mpf-who-http'
import { LIST_NAME as DiscussionListName } from '../../../assets/ts/data/discussions'
import {
  COLUMN_NAMES as DueOutColumns,
  DueOut as DueOutInterface,
  LIST_NAME as DueOutListName,
} from '../../../assets/ts/data/dueout/dueout'
import {
  COLUMN_NAMES as InquiryColumns,
  Inquiry as InquiryInterface,
  LIST_NAME as InquiryListName,
  PersonDetails,
} from '../../../assets/ts/data/inquiry/inquiry'
import { encodeHTML, formatBody, handleRoute, sendEmail, sendNotification } from '../../../assets/ts/general/general'
import Alert from '../../../components/alert/alert'
import DialogBox from '../../../components/alert/dialog-box'
import ActionButtons from '../../../components/buttons/action-buttons'
import Buttons from '../../../components/buttons/buttons'
import { UserContext } from '../../../store/user-context-provider'
import { CONCURRENCY_ERR_MSG } from '../../../utils/constants/global-constants'
import { DiscussionCols } from '../../../utils/constants/global-list-columns'
import NO_RESULTS from '../../../utils/constants/no-results'
import {
  DELETE_MESSAGE,
  NOT_SELECT_MESSAGE,
} from '../../../utils/constants/rhybus-config'
import CustomSelect from '../../../utils/controls/custom-select'
import InputCheckbox from '../../../utils/controls/input-checkbox'
import InputTextArea from '../../../utils/controls/input-text-area'
import MultiSelectInput from '../../../utils/controls/multi-input-text'
import './team-members.css'

const initialValues = ['addteammember']
let elementHeightValue: number
let offsetLeftValue: number
let offsetTopValue: number
let offsetWidthValue: number
let popupTop: number
let xPositionValue: any

interface TeamMembersProps {
  currentInquiry: DueOutInterface | InquiryInterface
  hideButton:boolean
  isInquiry: boolean
  refresh: boolean
  role: any
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
}
interface TeamMember {
  id: string
  mailId: string
  title: string
}
const TeamMembers = ({
  currentInquiry,
  hideButton,
  isInquiry = true,
  refresh,
  role,
  setRefresh
}: TeamMembersProps) => {
  /** *** Responsive Popup Code Start*****/
  const { multiplePopup, setMultiplePopup } = useContext(UserContext)
  const addteammember = useRef(null)
  const popupBtnRef = useRef(null)
  const [xPositionValueUpdate, setXPositionValueUpdate] = useState()
  const [popupHeight, setPopupHeight] = useState<number>()

  const [actionBtnShowHide, setActionBtnShowHide] = useState({
    addteammember: false,
  })
  const [showActionPopups, setShowActionPopups] = useState({
    addteammember: false,
  })
  const showHide: any = { ...actionBtnShowHide }

  function popupCloseOpenFunctionality(
    type: any,
    value: number,
    top: number,
    xPosition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number
  ) {
    popupTop = top
    xPositionValue = xPosition
    offsetLeftValue = left
    offsetTopValue = top
    offsetWidthValue = offsetWidth
    initialValues.forEach((element) => {
      showHide[element] = false
    })
    setActionBtnShowHide(showHide)
    if (type === multiplePopup) {
      setMultiplePopup()
    } else if (type) {
      setMultiplePopup(type)
    }
    setInputValues({ add: [], comment: '' })
    setInputValidation({ add: false, comment: false })
    setPeopleDropdownNames([])
  }

  useEffect(() => {
    setPopupHeight(window.innerHeight - (offsetTopValue + 65))
    const popupWidthData = popupBtnRef.current
      ? popupBtnRef.current.offsetWidth
      : 0
    // setpopupwidth(popupWidthData)
    if (popupWidthData < xPositionValue) {
      xPositionValue = xPositionValue - popupWidthData
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData < window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = offsetLeftValue
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData > window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = 0
      setXPositionValueUpdate(xPositionValue)
    }
  }, [multiplePopup])
  const errorMessageText = {
    add: 'please enter a name',
    customerExist: 'You cannot add the customer as a team member',
    exist: 'This team member already exists',
    name: 'Please enter a valid name',
  }
  interface DropdownName {
    id: string;
    label: string;
    mailId: string;
    value: string;
  }
  
  const [peopleDropdownNames, setPeopleDropdownNames] = useState<DropdownName[]>([])
  const [inputValues, setInputValues] = useState({
    add: [],
    comment: '',
  })
  const [teamMembers, setTeamMembers] = useState<Array<TeamMember>>([])
  const [deletedMembers, setDeletedMembers] = useState<Array<TeamMember>>([])
  const [inputValidation, setInputValidation] = useState({
    add: false,
    comment: false,
  })
  const [inquiry, setInquiry] = useState<DueOutInterface | InquiryInterface>()
  const [errorMSG, setErrorMSG] = useState<string>('')
  const [showAlert, setShowAlert] = useState(false)
  const [showConfirmReload, setShowConfirmReload] = useState<boolean>(false)
  const [confirmMessage, setConfirmMessage] = useState('')
  useEffect(() => {
    setMultiplePopup()
    setInquiry(currentInquiry)
    if (Array.isArray(currentInquiry?.TeamMembers)) {
      const members: TeamMember[] = currentInquiry.TeamMembers.map((item) => {
        return {
          id: item.userID,
          mailId: item.properties.email,
          title: item.properties.defaultDisplay,
        }
      })
      setTeamMembers(members)
    }
  }, [currentInquiry])
  const changeUser = async (value: string) => {
    if (value.trim().length > 2) {
      const userList = [...(await mpfWhoHttp().Picker(value.trim()))]
      let userObject = userList.map((item) => {
        return {
          id: item.rid,
          label: item.persona,
          mailId: item.email,
          value: item.rid,
        }
      })
      userObject = userObject.filter((item) => {
        return !inputValues.add.some((member) => member.id === item.id)
      })
      setPeopleDropdownNames(userObject)
    }
  }
  const handleInputChange = (inputValue: string) => {
    changeUser(inputValue)
  }
  const selectedUser = (team: any) => {
    setInputValues((prev) => ({
      ...prev,
      add: team,
    }))
    setPeopleDropdownNames([])
  }
  const changeComment = (e) => {
    setInputValues((prev) => ({ ...prev, comment: e.target.value }))
  }
  const validateTeamMember = () => {
    let isValid = false
    let addValidation = false
    let commentValidation = false
    setErrorMSG('')
    if (inputValues.add.length === 0) {
      setErrorMSG(errorMessageText.add)
      addValidation = true
    } else if (
      teamMembers.some((member) =>
        inputValues.add.some((newTeam: { value: string }) => member.id === newTeam.value)
      )
    ) {
      setErrorMSG(errorMessageText.exist)
      addValidation = true
    } else if (
      inputValues.add.some(
        (newTeam: { value: string }) =>
          (inquiry?.Customer as PersonDetails).userID === newTeam.value
      )
    ) {
      setErrorMSG(errorMessageText.customerExist)
      addValidation = true
    } 
    if (!inputValues.comment.trim()) {
      setErrorMSG(errorMessageText.name)
      commentValidation = true
    }
    isValid = !(addValidation || commentValidation)
  
    setInputValidation({ add: addValidation, comment: commentValidation })

    if (isValid) {
      addOrDeleteTeamMember('Added')
    }
  }

  const addOrDeleteTeamMember = async (action: string) => {
    const userdetails = await mpfRListsHttp().me()
    const userId = userdetails.userId
    const newTeamMembers: TeamMember[] =
      action === 'Added'
        ? [...teamMembers, ...inputValues.add]
        : teamMembers.filter(
          ({ id }) => !deletedMembers.some((member) => member.id === id)
        )
    const newTeamMemberIds: string[] = newTeamMembers.map(({ id }) => id)
    const updateInquiry: DueOutInterface | InquiryInterface = {
      ...inquiry,
      [InquiryColumns.ItemModified]: new Date(),
      [InquiryColumns.ItemModifiedBy]: userId,
      [InquiryColumns.TeamMembers]: newTeamMemberIds,
    }
    Object.keys(updateInquiry).forEach((key) => {
      if (key.includes('/')) {
        delete updateInquiry[key]
      }
    })
    try {
      const LISTNAME = isInquiry ? InquiryListName : DueOutListName
      const list = await mpfRListsHttp().getList(LISTNAME)
      const inquiry = await list.addOrUpdateItem(updateInquiry)
      const emails: Promise<any>[] = []
      setInquiry((prev) => ({
        ...prev,
        TeamMembers: inquiry.TeamMembers,
        eTag: inquiry.eTag,
      }))
      const updatedMember =
        action === 'Added'
          ? [...inputValues.add.map((item) => item.label)]
          : deletedMembers.map((item) => item.title)
      const batchItems: BatchOperation[] = []
      const targetListName = isInquiry
        ? DiscussionListName
        : 'DueOutDiscussionsList'
      for (let n = 0; n < updatedMember.length; n++) {
        const objectArray: any = {
          [DiscussionCols.Comment]: encodeHTML(inputValues.comment),
          [DiscussionCols.CommentType]: `${action} Team Member`,
          [DiscussionCols.IsActionComment]: false,
          [DiscussionCols.ItemCreated]: new Date(),
          [DiscussionCols.ItemCreatedBy]: userId,
          [DiscussionCols.ItemModified]: new Date(),
          [DiscussionCols.ItemModifiedBy]: userId,
          [DiscussionCols.Subject]: `${updatedMember[n]} has been ${action} as a Team Member`,
        }

        if (isInquiry) {
          objectArray[DiscussionCols.InquiryGUID] = inquiry.InquiryGUID
          objectArray[DiscussionCols.InquiryID] = inquiry.InquiryID
        } else {
          objectArray['DueOutGUID'] = inquiry.DueOutGUID
          objectArray['DueOutID'] = inquiry.DueOutID
        }
        if (action === 'Added') {
          emails.push(
            handleEmails(
              userdetails,
              isInquiry,
              action,
              newTeamMembers.some((tm) =>
                tm.title === updatedMember[n]) ?
                newTeamMembers.filter((tm) =>
                  tm.title === updatedMember[n])[0].id
                : ''
            ))
            await sendNotification(
              'TEAM_MEMBER_ADD', 
              currentInquiry, 
              userdetails, 
              role?.replace('[SECTION_NAME]', '').trim() || '', 
              !isInquiry)
        } else {
          emails.push(
            handleEmails(
              userdetails,
              isInquiry,
              action,
              deletedMembers.some((tm) =>
                tm.title === updatedMember[n]) ?
                deletedMembers.filter((tm) =>
                  tm.title === updatedMember[n])[0].id
                : ''
            ))
            await sendNotification(
              'TEAM_MEMBER_DELETE', 
              currentInquiry, 
              userdetails, 
              role?.replace('[SECTION_NAME]', '').trim() || '', 
              !isInquiry)
        }

        batchItems.push({
          data: objectArray,
          list: targetListName,
          op: BatchOperationAdd,
        } as BatchOperation)
      }
      await mpfRListsHttp()
        .createBatch(BatchModeTransaction, batchItems)
        .execute()
      await Promise.all(emails)
      setTeamMembers(newTeamMembers)
      setMultiplePopup()
      setDeletedMembers([])
      setRefresh(!refresh)
    } catch (error) {
      if (error instanceof ConcurrencyError) {
        setShowConfirmReload(true)
      } else {
        console.error(error)
      }
    }
  }

  const handleEmails = async (
    userdetails,
    isInquiry,
    action,
    teamMemberId
  ) => {

    const userId = userdetails.userId
    const detailView = isInquiry ? 'detailview' : 'dueoutdetailview'
    const dataGUID =
      isInquiry ? currentInquiry?.InquiryGUID : currentInquiry?.DueOutGUID
    const navURL = sitePath + `/${detailView}/${dataGUID}`
    const dataId =
      isInquiry ? currentInquiry?.InquiryID : currentInquiry?.DueOutID
    const bodyText = action === 'Added' ? '' : `You have been deleted as a Team Member for the ${isInquiry ? 'Inquiry' : 'Due Out'} '${dataId}'.`
    const emailBodyData = {
      ...currentInquiry,
      bodyText: bodyText,
      comment: encodeHTML(inputValues.comment),
    }

    const body = formatBody(`${action === 'Added' ? '' : 'Delete'}TeamMember`, emailBodyData, navURL)
    const to = currentInquiry?.Customer?.userID
    const formattedRole = role?.replace('[SECTION_NAME]', '').trim() || ''

    const emailObjData = {
      ...currentInquiry,
      Action: `${action === 'Added' ? 'Add' : 'Delete'} Team Member`,
      ItemGUID: dataGUID,
      ItemID: dataId,
      Title: currentInquiry?.Subject,
    }

    const emails: Promise<any>[] = []

    if (to && to !== userId) {
      emails.push(sendEmail({
        bcc: '',
        body: body,
        bodySurvey: '',
        cc: '',
        data: emailObjData,
        isDiscussion: false,
        isSurvey: false,
        loginuserId: userId,
        navURL: navURL,
        subject: `A${action === 'Added' ? ' new' : ''} team member has been ${action === 'Added' ? 'added' : 'deleted'} for ${isInquiry ? 'Inquiry' : 'Due Out'} '${dataId}' ${formattedRole && `by '${formattedRole}'`}`,
        to: to
      }))
    }

    const teamMemberBody = formatBody(`${action === 'Added' ? '' : 'Delete'}TeamMember`, emailBodyData, navURL)

    if (teamMemberId && teamMemberId !== userId) {
    emails.push(sendEmail({
        bcc: '',
        body: teamMemberBody, 
        bodySurvey: '',
        cc: '',
        data: emailObjData,
        isDiscussion: false,
        isSurvey: false,
        loginuserId: userId,
        navURL: navURL,
        subject: `You have been ${action === 'Added' ? 'added' : 'deleted'} as a team member for ${isInquiry ? 'Inquiry' : 'Due Out'} '${dataId}' ${formattedRole && `by '${formattedRole}'`}`,
        to: teamMemberId
      }))
    }

    await Promise.all(emails)
  }

  function changeCheckBox(e: {
    target: { ariaLabel: string; checked: boolean; id: string; value?: string }
  }) {
    const isChecked = e.target.checked
    const checkedMember: TeamMember = {
      id: e.target.id,
      mailId: e.target.value,
      title: e.target.ariaLabel,
    }
    const selectedTeamMember = isChecked
      ? [...deletedMembers, checkedMember]
      : deletedMembers.filter(({ id }) => id !== checkedMember.id)
    setDeletedMembers(selectedTeamMember)
  }

  function onDelete() {
    if (deletedMembers.length === 0) {
      setConfirmMessage(NOT_SELECT_MESSAGE)
    } else {
      setConfirmMessage(DELETE_MESSAGE)
    }
    setShowAlert(true)
  }

  const onClickAlert = async (button: string) => {
    if (button === 'Ok' && confirmMessage === DELETE_MESSAGE) {
      await addOrDeleteTeamMember('Deleted')
    }
    setShowAlert(false)
  }
  useEffect(() =>{
    if(multiplePopup){
      const element = document.getElementsByClassName('team-members-div')
    if(element){
      setTimeout(() =>{
        element?.[0]?.scrollIntoView({ behavior: 'smooth', block: 'end'})
      }, 100)
    }
    }
  }, [multiplePopup])
  return (
    <div className='shadow card w-100 mt-3 p-relative'>
      <div className='card-header border-bottom1 gap-2 flex-wrap d-flex align-items-center'>
        {showAlert && (
          <Alert
            alerttextclass='poppins-semibold font-13 text-center'
            btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
            btn1iconclassNmae='icon-checked font-12 pe-1'
            btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
            btn2iconclassNmae='icon-close color-primary font-12 pe-1'
            cancel='Cancel'
            className='alert-info'
            message={`${confirmMessage}`}
            onClick={onClickAlert}
            yes='Ok'
          />
        )}
        <div className='d-flex flex-wrap align-items-center'>
          <h2
            aria-label='Team Members'
            className='title-color20 poppins-semibold font-14 mx-1'
            tabIndex={0}
          >
            Team Members{' '}
            <span className='badge bgcolor-primary font-12 border-radius3 px-2 py-1 whitetext'>
              {teamMembers.length.toString().padStart(2, '0')}
            </span>
            <span
              className='tool-tip tooltip-right font-12 sourcesanspro'
              data-tip='Team Members'
            >
              <span className='icon-info color-primary font-13 ps-1'></span>
            </span>
          </h2>
        </div>
        <div className='ms-auto d-flex align-items-center gap-1'>
          {!inquiry?.ClosedDate && !hideButton && (
            <ActionButtons
              className={
                multiplePopup === 'addteammember'
                  ? 'btn-border btn btn-sm font-0 font-xxl-14 color-primary btn-border-radius3 p-relative popup-arrow  ms-auto sourcesansprosemibold'
                  : 'btn-border btn btn-sm font-0 font-xxl-14 color-primary btn-border-radius3 p-relative ms-auto sourcesansprosemibold'
              }
              icon='icon-add color-primary font-10 me-xxl-1 bold'
              isClick='addteammember'
              label='Add'
              name='Add'
              popupCloseOpenFunctionality={popupCloseOpenFunctionality}
              ref={addteammember}
              showHide={showActionPopups.addteammember}
              type='button'
            />
          )}
          {teamMembers && teamMembers?.length > 0 &&!inquiry?.ClosedDate && !hideButton && (
            <Buttons
              aria-label='Delete'
              className='btn-sm font-0 btn-border color-primary uppercase text-nowrap border-radius4 px-2'
              icon='icon-trashbin font-12'
              label='Delete'
              onClick={onDelete}
              type='button'
            />
          )}
        </div>
      </div>

      {multiplePopup === 'addteammember' ? (
        <div
          className='popup popup-sm'
          ref={popupBtnRef}
          style={{
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 8,
          }}
        >
          <div className='row'>
            <div className='col-md-12 mt-0 mb-2'>
              <MultiSelectInput
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={inputValidation.add}
              errorMsg={errorMSG}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='AddTeamMember '
              info='Add Team Member'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color', 
                placeholder: 'Enter Names or Email Addresses...',
              }}
              isInfo
              isMandatory={true}
              isMulti
              label='Add Team Member '
              menuPosition={'fixed'}
              name='Add Team Member'
              onChange={selectedUser}
              onInputChange={handleInputChange}
              options={peopleDropdownNames}
              value={inputValues.add}
            />
            </div>
          </div>
          <div className='col-md-12 mt-0'>
            <InputTextArea
              className='form-lg font-13 sourcesanspro  min-h-100 p-1'
              cols='30'
              error={inputValidation.comment}
              formClassName=' form-vertical'
              info='Comment'
              infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'font-12 poppins-medium title-color2 mb-1',
                id: 'Comment',
                name: 'Comment',
                placeholder: 'Enter your Comment',
                value: `${inputValues.comment}`,
              }}
              isInfo
              isMandatory
              label='Comment'
              onChange={changeComment}
              rows='3'
              type='textarea'
            />
          </div>
          <div className='pt-2 d-flex gap-2 team-members-div'>
            <Buttons
              aria-label='Ok'
              className='btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold'
              icon='icon-checked font-10 me-1'
              label='Ok'
              onClick={validateTeamMember}
            />
            <ActionButtons
              className='btn-border1 title-color3 btn-sm font-11 border-radius text-uppercase poppins-semibold'
              icon='icon-close font-9 me-1 color-primary'
              isClick='addteammember'
              label='Cancel'
              name='Cancel'
              popupCloseOpenFunctionality={popupCloseOpenFunctionality}
              ref={addteammember}
              showHide={showActionPopups.addteammember}
              type='button'
            />
          </div>
        </div>
      ) : (
        ''
      )}

      <div className='card-body teammemberlist'>
        {teamMembers && teamMembers?.length === 0 ? (
          <div>
          <NO_RESULTS/>
          </div>
        ) : (
          teamMembers.map((membersData) => (
            <div
              className='d-flex align-items-center mb-2 pb-2 border-bottom1'
              key={membersData.title}
            >
              <InputCheckbox
                formClassName='d-flex align-items-center me-2'
                inputProps={{
                  arialabel: membersData.title,
                  className: 'form-xs font-0',
                  id: membersData.id,
                  label: membersData.title,
                  type: 'checkbox',
                  value: membersData.mailId,
                }}
                onChange={changeCheckBox}
              />
              <div>
                <div
                  aria-label={membersData.title}
                  className='color-primary poppins-semibold font-12 maxfitcontent'
                  tabIndex={0}
                >
                  {membersData.title}
                </div>
                <div>
                  <a
                    className='title-color30 font-14 sourcesanspro'
                    href={`mailto:${membersData.mailId}`}
                    title={membersData.title}
                  >
                    {membersData.mailId}
                  </a>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      {showConfirmReload && (
        <DialogBox
          handleRouteNo={() => handleRoute('cancel', setShowConfirmReload)}
          handleRouteYes={handleRoute}
          message={CONCURRENCY_ERR_MSG}
          primaryText={'Ok'}
          secondaryText={'Cancel'}
        />
      )}
    </div>
  )
}
export default TeamMembers
